// Loader'ın iframe'leyeceği widget UI base URL'i.
// override (build-time __WIDGET_URL__) doluysa o kazanır (dev: vite :5174).
// Değilse loader kendi <script src> origin'inden türetir — loader ve widget UI
// aynı origin'de servis edilir (widget.<domain>, bkz. KNV-287), böylece tenant
// snippet'i ortamdan bağımsız sabittir.
export function resolveWidgetUrl(
	scriptSrc: string | null | undefined,
	override: string,
): string | null {
	if (override) {
		return override;
	}
	if (!scriptSrc) {
		return null;
	}
	try {
		return `${new URL(scriptSrc).origin}/widget/`;
	} catch {
		return null;
	}
}
